import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectCostTemplatesService {

  constructor(private apiService: ApiBaseService) { }

  async writeProjectcostTemplate(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostTemplatesService/WriteProjectcostTemplate', payLoad, true, true);
  }

  async getAllProjectCostTemplates(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostTemplatesService/GetAllProjectCostTemplates', payLoad, true, true);
  }

  async writeProjectCostTemplateCost(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostTemplatesService/WriteProjectCostTemplateCost', payLoad, true, true);
  }

  async deleteProjectCostTemplate(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostTemplatesService/DeleteProjectCostTemplate', payLoad, true, true);
  }

  async deleteProjectCostOnTemplate(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostTemplatesService/DeleteProjectCostOnTemplate', payLoad, true, true);
  }

}


